export const DOMAIN_NAMES = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "aol.com",
  "msn.com",
  "comcast.net",
  "live.com",
  "att.net",
  "mac.com",
  "me.com",
  "charter.net",
  "shaw.ca",
  "yahoo.ca",
  "mail.com",
  "qq.com",
  "web.de",
  "gmx.de",
  "mail.ru",
];
